module.exports = __webpack_public_path__ + "img/8_69.c8a04b86.png";